import { Component, OnInit } from '@angular/core';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';

@Component({
    selector: 'ups-radio-group',
    templateUrl: './radio-button.type.component.html',
    styleUrls: ['./radio-button.type.component.scss'],
    standalone: false
})
export class RadiobuttonTypeComponent extends FieldType implements OnInit {
  public fields: FormlyFieldConfig[] = [];

  constructor() {
    super();
  }

  ngOnInit() {
    this.fields = this.to['fields'];
  }
}
